const getItemsWithPrice = (values, form_settings, key, parentTotal) => {
    const valuesByKey = values[key];
    const formSettingsByKey = form_settings[key];
    const pricesByKey = values.prices[key];
    const parentNumber = false === parentTotal ? 1 : parentTotal.totalNumber;
    const priceItems = {
        items: [],
        totalPrice: 0,
        totalNumber: 0,
    };

    Object.keys(valuesByKey).map((id) => {
        if (valuesByKey[id]) {
            const item = formSettingsByKey.items[id];
            const pro =
                !item.info.hasOwnProperty("pro") || true == item.info.pro;
            const value = valuesByKey[id];

            const priceItem = {
                name: item.info.name,
                price: parseFloat(pricesByKey[id]),
                number: 0,
                totalPrice: 0,
            };

            if (value === true) {
                if (pro) {
                    priceItem.number = 1 * parentNumber;
                } else {
                    priceItem.number = 1;
                }
            } else {
                if (pro) {
                    priceItem.number = value * parentNumber;
                } else {
                    priceItem.number = value;
                }
            }

            priceItem.totalPrice = priceItem.number * priceItem.price;
            priceItems.items.push(priceItem);
            priceItems.totalPrice =
                priceItems.totalPrice + priceItem.totalPrice;
            priceItems.totalNumber =
                priceItems.totalNumber + priceItem.number;
        }
    });
    return priceItems.items.length > 0 ? priceItems : false;
};

export default getItemsWithPrice;